import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=5e2bf218&scoped=true&"
import script from "./Id.vue?vue&type=script&lang=js&"
export * from "./Id.vue?vue&type=script&lang=js&"
import style0 from "./Id.vue?vue&type=style&index=0&id=5e2bf218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bf218",
  null
  
)

export default component.exports